import React from 'react'
import moment from 'moment'
import range from 'lodash/range'
import concat from 'lodash/concat'
import OfferForm from './OfferForm'
import SpecialForm from './SpecialForm'

export default class Calendar extends React.Component {
    constructor(props) {
        super(props)
        this.prices = {
            labels: ['1 - 3 zile', '4 - 7 zile', '8 - 14 zile', '15 - 30 zile', 'peste 30 zile'],
            keys: ['p1', 'p2', 'p3', 'p4', 'p5']
        }
        this.start_month = moment(this.props.start_date || moment())
        this.months = []
        for (let i = 0; i < 12; i++) {
            this.months.push(moment(this.start_month.format('YYYY-MM-01')).add(i, 'months'))
        }
        this.state = {
            requests: (this.props.offers && this.props.offers.requests.map(r => [moment(r[0]), moment(r[1]), r[2]])) || [],
            specials: (this.props.offers && this.props.offers.specials.map(r => [moment(r[0]), moment(r[1]), r[2]])) || [],
            start: null,
            end: null,
            over: null
        }

        this.dayTypes = {
            request: 'request',
            requestSpecial: 'requestSpecial',
            boundary: 'boundary',
            empty: 'empty',
            emptyBoundary: 'emptyBoundary',
            specialBoundary: 'specialBoundary',
            emptyHighlighted: 'emptyHighlighted',
            requestHighlighted: 'requestHighlighted'
        }
    }

    inRange = (date, r) => {
        return date.isSame(r[0]) || date.isSame(r[1]) || date.isBetween(r[0], r[1])
    }

    resetSelection = () => {
        this.setState({start: null, end: null, over: null})
    }

    addSpecial = (ro_id, start, end) => {
         this.specialForm.addSpecial(ro_id, start, end)
    }
    editSpecial = (ro_id, rs_id) => {
        this.specialForm.editSpecial(ro_id, rs_id)
    }

    addOffer = (start, end) => {

        this.offerForm.addOffer(this.props.plg_id, start, end)
    }

    editOffer = (ro_id) => {
        this.offerForm.editOffer(this.props.plg_id, ro_id)
    }


    dayType = (date) => {

        const boundary = this.state.requests.find(r => (date.isSame(r[0]) || date.isSame(r[1])))
        if (boundary) {return {request_id: boundary[2], dayType: this.dayTypes.boundary}}

        const special = this.state.specials.find(r =>  this.inRange(date, r))
        const request = this.state.requests.find(r => this.inRange(date, r))
        if(!special &&
            (this.state.start && date.isSame(this.state.start) ||
                this.state.end && date.isSame(this.state.end)))
            return request ? {request_id: request[2], dayType: this.dayTypes.specialBoundary} : {dayType: this.dayTypes.emptyBoundary}


        if(!special && this.state.start &&
            (this.state.end || (this.state.over && this.state.over.isAfter(this.state.start))) &&
            (date.isBetween(this.state.start, (this.state.end || this.state.over)) || date.isSame(this.state.end || this.state.over))
        )    return request ? {request_id: request[2], dayType: this.dayTypes.requestHighlighted} : {dayType: this.dayTypes.emptyHighlighted}

        if (request) {
            return special ? {request_id: request[2], special_id: special[2], dayType: this.dayTypes.requestSpecial } : {request_id: request[2], dayType: this.dayTypes.request }
        }
        return {dayType: this.dayTypes.empty}
    }

    highlight = (selected, existing, ro_id = null) => {
        const {start} = this.state
        if (start && selected.isSame(start)) return this.resetSelection()
        if (start && selected.isBefore(start)) return this.setState({start: selected, end: null, over: null})
        if (!start) return this.setState({start: selected, end: null, over: null})
        this.setState({end: selected})
        existing ? this.addSpecial(ro_id, start, selected) : this.addOffer(start, selected)
    }

    selectPeriod = (e) => {
        e.preventDefault()
        e.stopPropagation()
        const selected = moment(e.currentTarget.dataset.tag)
        const dayType = e.currentTarget.dataset.daytype
        switch(dayType) {
            case this.dayTypes.requestSpecial :
                return this.editSpecial(e.currentTarget.dataset.offerid, e.currentTarget.dataset.specialid)
            case this.dayTypes.boundary :
                return this.editOffer(e.currentTarget.dataset.offerid)
            case this.dayTypes.request :
            case this.dayTypes.specialBoundary:
            case this.dayTypes.requestHighlighted :
                return this.highlight(selected, true, e.currentTarget.dataset.offerid)
            case this.dayTypes.empty :
            case this.dayTypes.emptyBoundary :
            case this.dayTypes.emptyHighlighted :
                return this.highlight(selected, false, e.currentTarget.dataset.offerid)
        }
    }

    mouseEnter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({over: moment(e.currentTarget.dataset.tag)})
    }

    renderDay = (date) => {
        const dayResult = this.dayType(date)
        return (
            <span
                key={date.format('M-D')}
                data-tag={date.format('YYYY-MM-DD')}
                data-daytype={dayResult.dayType}
                data-specialid={dayResult.special_id}
                data-offerid={dayResult.request_id}
                className={`day-default day-${dayResult.dayType}`}
                onClick={this.selectPeriod}
                onMouseEnter={this.mouseEnter}
                onMouseDown={(e) =>  this.selectPeriod(e)}
                onMouseUp={(e) =>  this.selectPeriod(e)}
            >
                {date.date()}
            </span>
        )
    }

    renderMonth = (date) => {
        const days = date.daysInMonth()
        return (
            <div key={date.format('YY-MM')} style={
                {
                    display: 'inline-block',
                    border: '1px solid lightgray',
                    padding: 5,
                    margin: 6,
                    width: 250,
                    minHeight: 180,
                }
            }>
                <div className={'mb-1'} style={{borderBottom: '1px solid gray'}}>{date.format('MMMM YYYY')}</div>
                <div>
                    {range(1, days + 1).map(d => this.renderDay(date.date(d)))}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                <OfferForm ref={e => this.offerForm = e} prices={this.prices}
                        addOffer={(new_offer) => {
                            this.setState({start: null, end: null, requests: concat(this.state.requests, [new_offer])})}
                        }
                           deleteOffer={() =>  this.props.reload && this.props.reload()}
                           baseUrl={this.props.baseUrl}
                           admin={this.props.admin}
                />
                <SpecialForm ref={e => this.specialForm = e} prices={this.prices}
                        clearSelection={() => this.setState({start: null, end: null})}
                             addOffer={(new_offer) => {
                                 this.setState({start: null, end: null, specials: concat(this.state.specials, [new_offer])})}
                             }
                             deleteOffer={() =>  this.props.reload && this.props.reload()}
                             baseUrl={this.props.baseUrl}
                            admin={this.props.admin}
                />
                {this.months.map(m => this.renderMonth(m))}
            </div>
        )
    }
}